import React from "react";
import { ContentHeader, ContentText } from "./styles";
import { __ } from "../../../lib/translate";
import styled from "styled-components";
import { boldConverter } from "../../../lib/componentifyConverters";
import Componentify from "react-componentify";

const CustomerJourneyContent = () => {
    return (
        <Wrapper>
            <ContentHeader>
                {__("tutorial_title_more_space", "Unlock More Space")}
            </ContentHeader>
            <ContentText>
                <Componentify
                    text={__(
                        "tutorial_message_more_space",
                        "Need extra storage? Click the upgrade option in your dashboard to expand your space."
                    )}
                    converters={[boldConverter]}
                />
            </ContentText>
        </Wrapper>
    );
};

export default CustomerJourneyContent;

const Wrapper = styled.div`
    width: 280px;
`;
